import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  it: {
    // Header
    home: 'Home',
    products: 'Prodotti',
    cart: 'Carrello',
    support: 'Assistenza',
    search: 'Cerca...',
    searchFull: 'Cerca prodotti...',
    collection: 'Collezione',
    fashion: 'Moda',
    casa: 'Casa',
    electronics: 'Elettronica',
    magazine: 'Magazine',
    academy: 'Academy',
    partner: 'Diventa Partner',
    // Hero - Homepage
    heroTitle: 'Scopri Prodotti Unici',
    heroSubtitle: '+2.300 prodotti selezionati. Spedizione gratuita sopra €50.',
    shopNow: 'Acquista Ora',
    viewCatalog: 'Scopri il catalogo',
    heroTagline: 'Lo shopping online semplice, veloce e affidabile.',
    heroDescription: 'Prodotti selezionati, spedizione rapida e supporto clienti dedicato.',
    newCollection: 'Nuova Collezione',
    exploreCollection: 'Esplora la Collezione',
    // Categories
    shopByCategory: 'Esplora per Categoria',
    viewAll: 'Vedi Tutto',
    newArrivals: 'Nuovi Arrivi',
    trending: 'In Tendenza',
    luxury: 'Lusso',
    offers: 'Offerte',
    // Quick Links
    discoverMagazine: 'Scopri il Magazine',
    latestTrends: 'Le ultime tendenze dal mondo della moda',
    exploreAcademy: 'Esplora l\'Academy',
    learnFromExperts: 'Impara dai migliori esperti',
    becomePartner: 'Diventa Partner',
    earnWithUs: 'Guadagna con QANTRI',
    // Products
    featuredProducts: 'Prodotti in Evidenza',
    allProducts: 'Tutti i Prodotti',
    addToCart: 'Aggiungi al Carrello',
    outOfStock: 'Esaurito',
    inStock: 'Disponibile',
    filterByCategory: 'Filtra per categoria',
    allCategories: 'Tutte le categorie',
    sortBy: 'Ordina per',
    priceAsc: 'Prezzo: crescente',
    priceDesc: 'Prezzo: decrescente',
    newest: 'Novità',
    noProducts: 'Nessun prodotto trovato',
    // Cart
    yourCart: 'Il Tuo Carrello',
    emptyCart: 'Il carrello è vuoto',
    continueShopping: 'Continua lo shopping',
    subtotal: 'Subtotale',
    checkout: 'Procedi al Checkout',
    remove: 'Rimuovi',
    quantity: 'Quantità',
    // Checkout
    checkoutTitle: 'Checkout',
    customerInfo: 'Informazioni Cliente',
    fullName: 'Nome Completo',
    email: 'Email',
    phone: 'Telefono',
    shippingAddress: 'Indirizzo di Spedizione',
    address: 'Indirizzo',
    city: 'Città',
    postalCode: 'CAP',
    country: 'Paese',
    orderNotes: 'Note Ordine',
    placeOrder: 'Effettua Ordine',
    payNow: 'Paga Ora',
    total: 'Totale',
    // Order
    orderConfirmed: 'Ordine Confermato',
    thankYou: 'Grazie per il tuo ordine!',
    orderNumber: 'Numero Ordine',
    orderStatus: 'Stato Ordine',
    trackOrder: 'Traccia Ordine',
    // Support
    supportTitle: 'Assistenza Clienti',
    createTicket: 'Crea un Ticket',
    subject: 'Oggetto',
    message: 'Messaggio',
    send: 'Invia',
    myTickets: 'I Miei Ticket',
    ticketStatus: {
      open: 'Aperto',
      in_progress: 'In Lavorazione',
      closed: 'Chiuso'
    },
    // News
    newsTitle: 'Tendenze & Lifestyle',
    newsSubtitle: 'Le ultime notizie dal mondo della moda, del design e del lifestyle.',
    freeNews: 'Gratuito',
    premiumNews: 'Premium',
    unlockAllNews: 'Sblocca tutte le notizie',
    subscribeToNews: 'Abbonati ora',
    perMonth: '/mese',
    unlimitedAccess: 'Accesso illimitato a tutte le notizie',
    updatesEvery12h: 'Aggiornamenti ogni 12 ore',
    cancelAnytime: 'Disdici quando vuoi',
    // Academy
    academyTitle: 'Investi nel tuo futuro',
    academySubtitle: 'Corsi professionali per chi vuole eccellere nel business, nella moda e nel design.',
    discoverMore: 'Scopri di più',
    buyCourse: 'Acquista corso',
    lessons: 'lezioni',
    hours: 'ore',
    students: 'studenti',
    courseDescription: 'Descrizione del corso',
    whatYouLearn: 'Cosa imparerai',
    courseProgram: 'Programma del corso',
    forWhom: 'A chi è rivolto',
    fullCourse: 'corso completo',
    oneTime: 'una tantum',
    buyNow: 'Acquista ora',
    loginToBuy: 'Accedi per acquistare',
    // Referral
    referralTitle: 'Programma Referral',
    referralSubtitle: 'Condividi QANTRI e guadagna',
    yourCode: 'Il tuo codice',
    shareAndEarn: 'Condividi e guadagna',
    inviteFriends: 'Invita amici',
    earnPerInvite: 'Guadagna per ogni amico invitato',
    loginToAccess: 'Accedi o registrati per ottenere il tuo codice referral e iniziare a guadagnare.',
    // Auth
    login: 'Accedi',
    register: 'Registrati',
    welcomeBack: 'Bentornato',
    createAccount: 'Crea il tuo account',
    loginPrompt: 'Accedi per gestire i tuoi ordini e guadagnare con i referral',
    registerPrompt: 'Unisciti a QANTRI per un\'esperienza di shopping esclusiva',
    yourName: 'Il tuo nome',
    password: 'Password',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
    // Footer
    footerAbout: 'QANTRI seleziona i migliori prodotti da tutto il mondo per offrirti la migliore esperienza di shopping.',
    quickLinks: 'Link Rapidi',
    aboutUs: 'Chi Siamo',
    contactUs: 'Contattaci',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Termini di Servizio',
    newsletter: 'Newsletter',
    subscribeText: 'Iscriviti per ricevere offerte esclusive',
    subscribe: 'Iscriviti',
    allRightsReserved: 'Tutti i diritti riservati',
    faq: 'Domande Frequenti',
    // Common
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',
    close: 'Chiudi',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    // Status
    status: {
      pending_payment: 'In Attesa Pagamento',
      new: 'Nuovo',
      ordered_from_supplier: 'Ordinato al Fornitore',
      shipped: 'Spedito',
      completed: 'Completato',
      cancelled: 'Annullato'
    }
  },
  en: {
    home: 'Home',
    products: 'Products',
    cart: 'Cart',
    support: 'Support',
    search: 'Search products...',
    collection: 'Collection',
    fashion: 'Fashion',
    casa: 'Home',
    electronics: 'Electronics',
    magazine: 'Magazine',
    academy: 'Academy',
    partner: 'Become Partner',
    heroTitle: 'Discover Unique Products',
    heroSubtitle: 'Over 2,000 selected products. Free shipping over €50.',
    shopNow: 'Shop Now',
    viewCatalog: 'View Catalog',
    heroTagline: 'The best, selected for you.',
    heroDescription: 'Fashion, Tech, Home and much more.',
    newCollection: 'Discover Exclusive Arrivals',
    exploreCollection: 'Explore Collection',
    shopByCategory: 'Shop by Category',
    viewAll: 'View All',
    newArrivals: 'New Arrivals',
    trending: 'Trending',
    luxury: 'Luxury',
    offers: 'Offers',
    discoverMagazine: 'Discover the Magazine',
    latestTrends: 'The latest trends from the fashion world',
    exploreAcademy: 'Explore the Academy',
    learnFromExperts: 'Learn from the best experts',
    becomePartner: 'Become a Partner',
    earnWithUs: 'Earn with QANTRI',
    featuredProducts: 'Featured Products',
    allProducts: 'All Products',
    addToCart: 'Add to Cart',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    filterByCategory: 'Filter by category',
    allCategories: 'All categories',
    sortBy: 'Sort by',
    priceAsc: 'Price: low to high',
    priceDesc: 'Price: high to low',
    newest: 'Newest',
    noProducts: 'No products found',
    yourCart: 'Your Cart',
    emptyCart: 'Your cart is empty',
    continueShopping: 'Continue Shopping',
    subtotal: 'Subtotal',
    checkout: 'Proceed to Checkout',
    remove: 'Remove',
    quantity: 'Quantity',
    checkoutTitle: 'Checkout',
    customerInfo: 'Customer Information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    shippingAddress: 'Shipping Address',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    orderNotes: 'Order Notes',
    placeOrder: 'Place Order',
    payNow: 'Pay Now',
    total: 'Total',
    orderConfirmed: 'Order Confirmed',
    thankYou: 'Thank you for your order!',
    orderNumber: 'Order Number',
    orderStatus: 'Order Status',
    trackOrder: 'Track Order',
    supportTitle: 'Customer Support',
    createTicket: 'Create a Ticket',
    subject: 'Subject',
    message: 'Message',
    send: 'Send',
    myTickets: 'My Tickets',
    ticketStatus: { open: 'Open', in_progress: 'In Progress', closed: 'Closed' },
    newsTitle: 'Trends & Lifestyle',
    newsSubtitle: 'The latest news from the world of fashion, design and lifestyle.',
    freeNews: 'Free',
    premiumNews: 'Premium',
    unlockAllNews: 'Unlock all news',
    subscribeToNews: 'Subscribe now',
    perMonth: '/month',
    unlimitedAccess: 'Unlimited access to all news',
    updatesEvery12h: 'Updates every 12 hours',
    cancelAnytime: 'Cancel anytime',
    academyTitle: 'Invest in your future',
    academySubtitle: 'Professional courses for those who want to excel in business, fashion and design.',
    discoverMore: 'Discover more',
    buyCourse: 'Buy course',
    lessons: 'lessons',
    hours: 'hours',
    students: 'students',
    courseDescription: 'Course description',
    whatYouLearn: 'What you will learn',
    courseProgram: 'Course program',
    forWhom: 'Who is it for',
    fullCourse: 'full course',
    oneTime: 'one time',
    buyNow: 'Buy now',
    loginToBuy: 'Login to buy',
    referralTitle: 'Referral Program',
    referralSubtitle: 'Share QANTRI and earn',
    yourCode: 'Your code',
    shareAndEarn: 'Share and earn',
    inviteFriends: 'Invite friends',
    earnPerInvite: 'Earn for every friend invited',
    loginToAccess: 'Login or register to get your referral code and start earning.',
    login: 'Login',
    register: 'Register',
    welcomeBack: 'Welcome back',
    createAccount: 'Create your account',
    loginPrompt: 'Login to manage your orders and earn with referrals',
    registerPrompt: 'Join QANTRI for an exclusive shopping experience',
    yourName: 'Your name',
    password: 'Password',
    noAccount: 'Don\'t have an account?',
    hasAccount: 'Already have an account?',
    footerAbout: 'QANTRI selects the best products from around the world to offer you the best shopping experience.',
    quickLinks: 'Quick Links',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    newsletter: 'Newsletter',
    subscribeText: 'Subscribe for exclusive offers',
    subscribe: 'Subscribe',
    allRightsReserved: 'All rights reserved',
    faq: 'FAQ',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    close: 'Close',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    status: { pending_payment: 'Pending Payment', new: 'New', ordered_from_supplier: 'Ordered from Supplier', shipped: 'Shipped', completed: 'Completed', cancelled: 'Cancelled' }
  },
  es: {
    home: 'Inicio',
    products: 'Productos',
    cart: 'Carrito',
    support: 'Soporte',
    search: 'Buscar productos...',
    collection: 'Colección',
    fashion: 'Moda',
    casa: 'Hogar',
    electronics: 'Electrónica',
    magazine: 'Magazine',
    academy: 'Academy',
    partner: 'Ser Socio',
    heroTitle: 'Descubre Productos Únicos',
    heroSubtitle: 'Más de 2.000 productos seleccionados. Envío gratis desde €50.',
    shopNow: 'Comprar Ahora',
    viewCatalog: 'Ver Catálogo',
    heroTagline: 'Lo mejor, seleccionado para ti.',
    heroDescription: 'Moda, Tech, Hogar y mucho más.',
    newCollection: 'Descubre las Novedades Exclusivas',
    exploreCollection: 'Explorar Colección',
    shopByCategory: 'Comprar por Categoría',
    viewAll: 'Ver Todo',
    newArrivals: 'Novedades',
    trending: 'Tendencias',
    luxury: 'Lujo',
    offers: 'Ofertas',
    discoverMagazine: 'Descubre el Magazine',
    latestTrends: 'Las últimas tendencias del mundo de la moda',
    exploreAcademy: 'Explora la Academy',
    learnFromExperts: 'Aprende de los mejores expertos',
    becomePartner: 'Conviértete en Socio',
    earnWithUs: 'Gana con QANTRI',
    featuredProducts: 'Productos Destacados',
    allProducts: 'Todos los Productos',
    addToCart: 'Añadir al Carrito',
    outOfStock: 'Agotado',
    inStock: 'Disponible',
    filterByCategory: 'Filtrar por categoría',
    allCategories: 'Todas las categorías',
    sortBy: 'Ordenar por',
    priceAsc: 'Precio: menor a mayor',
    priceDesc: 'Precio: mayor a menor',
    newest: 'Novedades',
    noProducts: 'No se encontraron productos',
    yourCart: 'Tu Carrito',
    emptyCart: 'Tu carrito está vacío',
    continueShopping: 'Continuar Comprando',
    subtotal: 'Subtotal',
    checkout: 'Proceder al Pago',
    remove: 'Eliminar',
    quantity: 'Cantidad',
    checkoutTitle: 'Pago',
    customerInfo: 'Información del Cliente',
    fullName: 'Nombre Completo',
    email: 'Correo',
    phone: 'Teléfono',
    shippingAddress: 'Dirección de Envío',
    address: 'Dirección',
    city: 'Ciudad',
    postalCode: 'Código Postal',
    country: 'País',
    orderNotes: 'Notas del Pedido',
    placeOrder: 'Realizar Pedido',
    payNow: 'Pagar Ahora',
    total: 'Total',
    orderConfirmed: 'Pedido Confirmado',
    thankYou: '¡Gracias por tu pedido!',
    orderNumber: 'Número de Pedido',
    orderStatus: 'Estado del Pedido',
    trackOrder: 'Rastrear Pedido',
    supportTitle: 'Soporte al Cliente',
    createTicket: 'Crear un Ticket',
    subject: 'Asunto',
    message: 'Mensaje',
    send: 'Enviar',
    myTickets: 'Mis Tickets',
    ticketStatus: { open: 'Abierto', in_progress: 'En Proceso', closed: 'Cerrado' },
    newsTitle: 'Tendencias y Estilo de Vida',
    newsSubtitle: 'Las últimas noticias del mundo de la moda, diseño y estilo de vida.',
    freeNews: 'Gratis',
    premiumNews: 'Premium',
    unlockAllNews: 'Desbloquear todas las noticias',
    subscribeToNews: 'Suscríbete ahora',
    perMonth: '/mes',
    unlimitedAccess: 'Acceso ilimitado a todas las noticias',
    updatesEvery12h: 'Actualizaciones cada 12 horas',
    cancelAnytime: 'Cancela cuando quieras',
    academyTitle: 'Invierte en tu futuro',
    academySubtitle: 'Cursos profesionales para quienes quieren destacar en negocios, moda y diseño.',
    discoverMore: 'Descubrir más',
    buyCourse: 'Comprar curso',
    lessons: 'lecciones',
    hours: 'horas',
    students: 'estudiantes',
    courseDescription: 'Descripción del curso',
    whatYouLearn: 'Lo que aprenderás',
    courseProgram: 'Programa del curso',
    forWhom: 'Para quién es',
    fullCourse: 'curso completo',
    oneTime: 'pago único',
    buyNow: 'Comprar ahora',
    loginToBuy: 'Inicia sesión para comprar',
    referralTitle: 'Programa de Referidos',
    referralSubtitle: 'Comparte QANTRI y gana',
    yourCode: 'Tu código',
    shareAndEarn: 'Comparte y gana',
    inviteFriends: 'Invita amigos',
    earnPerInvite: 'Gana por cada amigo invitado',
    loginToAccess: 'Inicia sesión o regístrate para obtener tu código de referido.',
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    welcomeBack: 'Bienvenido de nuevo',
    createAccount: 'Crea tu cuenta',
    loginPrompt: 'Inicia sesión para gestionar tus pedidos y ganar con referidos',
    registerPrompt: 'Únete a QANTRI para una experiencia de compra exclusiva',
    yourName: 'Tu nombre',
    password: 'Contraseña',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    footerAbout: 'QANTRI selecciona los mejores productos del mundo para ofrecerte la mejor experiencia de compra.',
    quickLinks: 'Enlaces Rápidos',
    aboutUs: 'Sobre Nosotros',
    contactUs: 'Contáctanos',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    newsletter: 'Boletín',
    subscribeText: 'Suscríbete para ofertas exclusivas',
    subscribe: 'Suscribirse',
    allRightsReserved: 'Todos los derechos reservados',
    faq: 'Preguntas Frecuentes',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    close: 'Cerrar',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    status: { pending_payment: 'Pago Pendiente', new: 'Nuevo', ordered_from_supplier: 'Pedido al Proveedor', shipped: 'Enviado', completed: 'Completado', cancelled: 'Cancelado' }
  },
  fr: {
    home: 'Accueil',
    products: 'Produits',
    cart: 'Panier',
    support: 'Support',
    search: 'Rechercher des produits...',
    collection: 'Collection',
    fashion: 'Mode',
    casa: 'Maison',
    electronics: 'Électronique',
    magazine: 'Magazine',
    academy: 'Académie',
    partner: 'Devenir Partenaire',
    heroTitle: 'Découvrez des Produits Uniques',
    heroSubtitle: 'Plus de 2 000 produits sélectionnés. Livraison gratuite dès 50€.',
    shopNow: 'Acheter Maintenant',
    viewCatalog: 'Voir le Catalogue',
    heroTagline: 'Le meilleur, sélectionné pour vous.',
    heroDescription: 'Mode, Tech, Maison et bien plus.',
    newCollection: 'Découvrez les Nouveautés Exclusives',
    exploreCollection: 'Explorer la Collection',
    shopByCategory: 'Acheter par Catégorie',
    viewAll: 'Voir Tout',
    newArrivals: 'Nouveautés',
    trending: 'Tendances',
    luxury: 'Luxe',
    offers: 'Offres',
    discoverMagazine: 'Découvrir le Magazine',
    latestTrends: 'Les dernières tendances du monde de la mode',
    exploreAcademy: 'Explorer l\'Académie',
    learnFromExperts: 'Apprenez des meilleurs experts',
    becomePartner: 'Devenir Partenaire',
    earnWithUs: 'Gagnez avec QANTRI',
    featuredProducts: 'Produits en Vedette',
    allProducts: 'Tous les Produits',
    addToCart: 'Ajouter au Panier',
    outOfStock: 'Rupture de Stock',
    inStock: 'Disponible',
    filterByCategory: 'Filtrer par catégorie',
    allCategories: 'Toutes les catégories',
    sortBy: 'Trier par',
    priceAsc: 'Prix: croissant',
    priceDesc: 'Prix: décroissant',
    newest: 'Nouveautés',
    noProducts: 'Aucun produit trouvé',
    yourCart: 'Votre Panier',
    emptyCart: 'Votre panier est vide',
    continueShopping: 'Continuer les Achats',
    subtotal: 'Sous-total',
    checkout: 'Passer à la Caisse',
    remove: 'Supprimer',
    quantity: 'Quantité',
    checkoutTitle: 'Paiement',
    customerInfo: 'Informations Client',
    fullName: 'Nom Complet',
    email: 'Email',
    phone: 'Téléphone',
    shippingAddress: 'Adresse de Livraison',
    address: 'Adresse',
    city: 'Ville',
    postalCode: 'Code Postal',
    country: 'Pays',
    orderNotes: 'Notes de Commande',
    placeOrder: 'Passer la Commande',
    payNow: 'Payer Maintenant',
    total: 'Total',
    orderConfirmed: 'Commande Confirmée',
    thankYou: 'Merci pour votre commande!',
    orderNumber: 'Numéro de Commande',
    orderStatus: 'Statut de la Commande',
    trackOrder: 'Suivre la Commande',
    supportTitle: 'Support Client',
    createTicket: 'Créer un Ticket',
    subject: 'Sujet',
    message: 'Message',
    send: 'Envoyer',
    myTickets: 'Mes Tickets',
    ticketStatus: { open: 'Ouvert', in_progress: 'En Cours', closed: 'Fermé' },
    newsTitle: 'Tendances & Lifestyle',
    newsSubtitle: 'Les dernières nouvelles du monde de la mode, du design et du lifestyle.',
    freeNews: 'Gratuit',
    premiumNews: 'Premium',
    unlockAllNews: 'Débloquer toutes les actualités',
    subscribeToNews: 'S\'abonner maintenant',
    perMonth: '/mois',
    unlimitedAccess: 'Accès illimité à toutes les actualités',
    updatesEvery12h: 'Mises à jour toutes les 12 heures',
    cancelAnytime: 'Annulez quand vous voulez',
    academyTitle: 'Investissez dans votre avenir',
    academySubtitle: 'Cours professionnels pour ceux qui veulent exceller.',
    discoverMore: 'En savoir plus',
    buyCourse: 'Acheter le cours',
    lessons: 'leçons',
    hours: 'heures',
    students: 'étudiants',
    courseDescription: 'Description du cours',
    whatYouLearn: 'Ce que vous apprendrez',
    courseProgram: 'Programme du cours',
    forWhom: 'À qui s\'adresse-t-il',
    fullCourse: 'cours complet',
    oneTime: 'paiement unique',
    buyNow: 'Acheter maintenant',
    loginToBuy: 'Connectez-vous pour acheter',
    referralTitle: 'Programme de Parrainage',
    referralSubtitle: 'Partagez QANTRI et gagnez',
    yourCode: 'Votre code',
    shareAndEarn: 'Partagez et gagnez',
    inviteFriends: 'Invitez des amis',
    earnPerInvite: 'Gagnez pour chaque ami invité',
    loginToAccess: 'Connectez-vous pour obtenir votre code de parrainage.',
    login: 'Connexion',
    register: 'S\'inscrire',
    welcomeBack: 'Bienvenue',
    createAccount: 'Créez votre compte',
    loginPrompt: 'Connectez-vous pour gérer vos commandes',
    registerPrompt: 'Rejoignez QANTRI pour une expérience shopping exclusive',
    yourName: 'Votre nom',
    password: 'Mot de passe',
    noAccount: 'Pas de compte?',
    hasAccount: 'Déjà un compte?',
    footerAbout: 'QANTRI sélectionne les meilleurs produits du monde pour vous offrir la meilleure expérience shopping.',
    quickLinks: 'Liens Rapides',
    aboutUs: 'À Propos',
    contactUs: 'Contactez-nous',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions de Service',
    newsletter: 'Newsletter',
    subscribeText: 'Inscrivez-vous pour des offres exclusives',
    subscribe: "S'inscrire",
    allRightsReserved: 'Tous droits réservés',
    faq: 'FAQ',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    close: 'Fermer',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    status: { pending_payment: 'Paiement en Attente', new: 'Nouveau', ordered_from_supplier: 'Commandé au Fournisseur', shipped: 'Expédié', completed: 'Terminé', cancelled: 'Annulé' }
  },
  zh: {
    home: '首页',
    products: '产品',
    cart: '购物车',
    support: '支持',
    search: '搜索产品...',
    collection: '系列',
    fashion: '时尚',
    casa: '家居',
    electronics: '电子',
    magazine: '杂志',
    academy: '学院',
    partner: '成为合作伙伴',
    heroTitle: '发现独特产品',
    heroSubtitle: '超过2000件精选产品。满50欧免邮。',
    shopNow: '立即购买',
    viewCatalog: '浏览目录',
    heroTagline: '精选好物，只为你。',
    heroDescription: '时尚、科技、家居等更多精选。',
    newCollection: '新品系列上线',
    exploreCollection: '探索系列',
    shopByCategory: '按类别购物',
    viewAll: '查看全部',
    newArrivals: '新品上市',
    trending: '热门趋势',
    luxury: '奢华',
    offers: '优惠',
    discoverMagazine: '探索杂志',
    latestTrends: '时尚界最新趋势',
    exploreAcademy: '探索学院',
    learnFromExperts: '向最好的专家学习',
    becomePartner: '成为合作伙伴',
    earnWithUs: '与QANTRI一起赚钱',
    featuredProducts: '精选产品',
    allProducts: '所有产品',
    addToCart: '加入购物车',
    outOfStock: '缺货',
    inStock: '有货',
    filterByCategory: '按类别筛选',
    allCategories: '所有类别',
    sortBy: '排序',
    priceAsc: '价格：从低到高',
    priceDesc: '价格：从高到低',
    newest: '最新',
    noProducts: '未找到产品',
    yourCart: '您的购物车',
    emptyCart: '购物车是空的',
    continueShopping: '继续购物',
    subtotal: '小计',
    checkout: '结账',
    remove: '删除',
    quantity: '数量',
    checkoutTitle: '结账',
    customerInfo: '客户信息',
    fullName: '全名',
    email: '邮箱',
    phone: '电话',
    shippingAddress: '送货地址',
    address: '地址',
    city: '城市',
    postalCode: '邮编',
    country: '国家',
    orderNotes: '订单备注',
    placeOrder: '下单',
    payNow: '立即支付',
    total: '总计',
    orderConfirmed: '订单已确认',
    thankYou: '感谢您的订单！',
    orderNumber: '订单号',
    orderStatus: '订单状态',
    trackOrder: '追踪订单',
    supportTitle: '客户支持',
    createTicket: '创建工单',
    subject: '主题',
    message: '消息',
    send: '发送',
    myTickets: '我的工单',
    ticketStatus: { open: '开放', in_progress: '处理中', closed: '已关闭' },
    newsTitle: '趋势与生活方式',
    newsSubtitle: '来自时尚、设计和生活方式世界的最新消息。',
    freeNews: '免费',
    premiumNews: '高级',
    unlockAllNews: '解锁所有新闻',
    subscribeToNews: '立即订阅',
    perMonth: '/月',
    unlimitedAccess: '无限制访问所有新闻',
    updatesEvery12h: '每12小时更新',
    cancelAnytime: '随时取消',
    academyTitle: '投资您的未来',
    academySubtitle: '为追求卓越的人提供的专业课程。',
    discoverMore: '了解更多',
    buyCourse: '购买课程',
    lessons: '课程',
    hours: '小时',
    students: '学生',
    courseDescription: '课程描述',
    whatYouLearn: '您将学到什么',
    courseProgram: '课程大纲',
    forWhom: '适合人群',
    fullCourse: '完整课程',
    oneTime: '一次性付款',
    buyNow: '立即购买',
    loginToBuy: '登录购买',
    referralTitle: '推荐计划',
    referralSubtitle: '分享QANTRI并赚取收益',
    yourCode: '您的代码',
    shareAndEarn: '分享并赚取',
    inviteFriends: '邀请朋友',
    earnPerInvite: '每邀请一位朋友即可获得奖励',
    loginToAccess: '登录或注册以获取您的推荐代码。',
    login: '登录',
    register: '注册',
    welcomeBack: '欢迎回来',
    createAccount: '创建账户',
    loginPrompt: '登录以管理订单并通过推荐赚取收益',
    registerPrompt: '加入QANTRI，享受独家购物体验',
    yourName: '您的姓名',
    password: '密码',
    noAccount: '没有账户？',
    hasAccount: '已有账户？',
    footerAbout: 'QANTRI精选全球优质产品，为您提供最佳购物体验。',
    quickLinks: '快速链接',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    newsletter: '通讯',
    subscribeText: '订阅获取独家优惠',
    subscribe: '订阅',
    allRightsReserved: '版权所有',
    faq: '常见问题',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    close: '关闭',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    status: { pending_payment: '待付款', new: '新订单', ordered_from_supplier: '已订购', shipped: '已发货', completed: '已完成', cancelled: '已取消' }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('qantri_lang') || 'it';
  });

  useEffect(() => {
    localStorage.setItem('qantri_lang', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
